/**
 * 룸 화면 의존성 — 연결(Colyseus · 늦게 불러옴)과 3D 뷰(C-02 전시관 뷰 재사용). 시험은 setRoomDepsForTests 로 바꾼다.
 * 가짜 모드(VITE_FIELD_FAKE=1 · 개발 서버)는 가짜 연결(dev/fake/fakeRoomWire — 가짜 룸 상태를 IF-06 바이트로 흉내)을 쓴다.
 */
import { readConfig } from "../../../lib/config";
import { courseDeps, type GalleryViewFactory } from "../../course";
import type { createPredictWorld } from "./predictWorld";
import type { Connect, PredictWorld, StartStageTest } from "../types";

export interface RoomDeps {
  connect: Connect;
  createGalleryView: GalleryViewFactory;
  now: () => number;
  /** 내 기계 예측 월드(SR-NET-03) — null 이면 예측 없이 보간만(시험 · 가짜 모드) */
  createPredictWorld:
    ((o: Parameters<typeof createPredictWorld>[0]) => Promise<PredictWorld>) | null;
  /** P3-S2 ▶ 내 구간 시험(로컬 · local-host startRelayStageTest) — 가짜 모드는 시간 흉내 */
  startStageTest: StartStageTest;
}

const defaults: RoomDeps = {
  connect: async (t) =>
    import.meta.env.DEV && readConfig().fake
      ? (await import("../../../dev/fake/fakeRoomWire")).fakeConnect(t)
      : (await import("./colyseus")).colyseusConnect(t),
  createGalleryView: (canvas, opts) => courseDeps().createGalleryView(canvas, opts),
  now: () => performance.now(),
  createPredictWorld: async (o) => (await import("./predictWorld")).createPredictWorld(o),
  startStageTest: async (req) =>
    import.meta.env.DEV && readConfig().fake
      ? (await import("../../../dev/fake/fakeStageTest")).fakeStartStageTest(req)
      : (await import("./stageTest")).startLocalStageTest(req),
};

let current: RoomDeps = defaults;

export function roomDeps(): RoomDeps {
  return current;
}

/** 시험 전용 — 부분만 바꾸고, null 이면 기본값으로 */
export function setRoomDepsForTests(over: Partial<RoomDeps> | null) {
  current = over ? { ...defaults, ...over } : defaults;
}
